import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { IdentifiedProfileList, DiscoveryWizard } from './';

export { Layout };

function Layout() {
    return (
        <div className="p-4">
            <div className="container">
                <Routes>
                    <Route index element={<DiscoveryWizard />} />
                    <Route path="identified_profiles" index element={<IdentifiedProfileList />} />
                    {/*<Route path="add" element={<AddEdit />} />*/}
                    {/*<Route path="edit/:id" element={<AddEdit />} />*/}
                </Routes>
            </div>
        </div>
    );
}
